import { CodeBlockBracketsIcon } from './CodeBlockBracketsIcon';

/**
 * author: frankgrinaert
 * id 5138F119-7F73-4A34-ACB8-CDB00042AAB6
 * name code-block-brackets
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/code-block-brackets.svg
 * tags
 * - Developer / Languages 
 */
export const CodeBlockSquareIcon = CodeBlockBracketsIcon;
export default CodeBlockSquareIcon